import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Text from '../../Datatypes/Text';
import Select from '../../Datatypes/Select';
import MultiSelect from '../../Datatypes/MultiSelect';
import Checkbox from '../../Datatypes/Checkbox';
import Stars from '../../Datatypes/Stars';
import Contact from '../../Datatypes/Contact';
import User from '../../Datatypes/User';
import Lookup from '../../Datatypes/Lookup';
import { ObjModal } from '../../../../contexts';


const Section = ( { title, body, id = 'gen', gPick, lists } ) => {
    const [ expanded, setExpanded ] = useState( true );
    const [ picklists, setPicklists ] = useState( {} );
    const { obj, oid, objPick } = useContext( ObjModal );

    useEffect( () => {
        let list = {};
        console.log( 'gpick:', gPick );
        console.log( 'objpick:', objPick );
        Object.keys( gPick ).forEach( l => {
            if ( typeof gPick[l] === 'object' ) {
                list[l] = [ ...gPick[l] ];
            } else if ( typeof gPick[l] === 'string' ) {
                list[l] = [ ...gPick[gPick[l]] ];
            }
        } );
        Object.keys( objPick ).forEach( l => {
            if ( typeof objPick[l] === 'object' ) {
                list[l] = [ ...objPick[l] ];
            } else if ( typeof objPick[l] === 'string' ) {
                console.log( 'l:', l );
                console.log( 'objPick[l]:', objPick[l] );
                list[l] = [ ...gPick[objPick[l]] ];
            }
        } );
        setPicklists( { ...list } );
    }, [ gPick, objPick ] );

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    const renderDataType = ( field ) => {
        let el = null;
        let disabled = ( field.disabled ) ? true : false;

        switch ( field.type ) {
            case 'text':
            case 'date':
            case 'email':
            case 'phone':
            case 'url':
            case 'textarea':
                el = <Text key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} type={field.type} disabled={disabled} />;
                break;

            case 'select':
                el = <Select key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} options={picklists} bucket={obj.details['status']} />;
                break;

            case 'multiselect':
                el = <MultiSelect key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} options={picklists} bucket={obj.details['status']} />;
                break;

            case 'checkbox':
                el = <Checkbox key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} />;
                break;

            case 'stars':
                el = <Stars key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} />;
                break;

            case 'contact':
                el = <Contact key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} aid={obj.details.aid} />;
                break;

            case 'user':
                el = <User key={`${oid}-${field.db}`} label={field.label} db={field.db} value={obj.details[field.db]} ul={lists.team} />;
                break;

            case 'lookup':
                el = <Lookup label={field.label} db={field.db} related={field.obj} formId={id} />
                break;
    
            default:
                if ( field.db ) {
                    el = <Col key={`${oid}-${field.db}`} className='tf-obj-data-element'>{field.label}: {obj.details[field.db]}</Col>;
                } else {
                    el = <Col key={Math.random()} className='tf-obj-data-element'>&nbsp;</Col>;
                }
        }
        
        return el;
    }

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>{title}</Typography></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    {
                        body.map( ( b, idx ) => {
                            if ( b.length ) {
                                return (
                                    <ListGroup.Item key={idx} className='border-0 py-0'>
                                        <Row className='align-items-center'>
                                            {
                                                b.map( ( field ) => ( renderDataType( field ) ) )
                                            }
                                        </Row>
                                    </ListGroup.Item>
                                )
                            }
                            return <ListGroup.Item key={idx} className='border-0 py-0'><Row className='align-items-center'><Col>&nbsp;</Col></Row></ListGroup.Item>;
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    gPick: state.user.meta.global.picklist,
    lists: state.user.lists
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( Section );